import { GET_CAMPAIGN_LIST } from "../helpers/api-path";
import httpClient from "./http.interceptor";


const getCampaignListAPI = async ({limit, lastKey, type, direction }) => {
    return await httpClient.get(GET_CAMPAIGN_LIST, {
        params: {
            ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
            limit,
            lastKey,
            type,
            direction
        }
    });
}

export {
    getCampaignListAPI
}